module.exports = __webpack_public_path__ + "img/3.42da18c6.jpg";